/**
 * This file defines the route for system users (= Pasona personnel) of the application.
 * It sets up the layout for system routes, rendering an `Outlet` for nested routes.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/system')({
    component: SystemLayout,
});

function SystemLayout() {
    return <Outlet />;
}
